// src/reducers/hdfcRetailUPReducers.js
import {
  GET_ALL_HDFC_RETAIL_UP_REQUEST,
  GET_ALL_HDFC_RETAIL_UP_SUCCESS,
  GET_ALL_HDFC_RETAIL_UP_FAIL,
  IMPORT_HDFC_RETAIL_UP_REQUEST,
  IMPORT_HDFC_RETAIL_UP_SUCCESS,
  IMPORT_HDFC_RETAIL_UP_FAIL,
  EXPORT_HDFC_RETAIL_UP_REQUEST,
  EXPORT_HDFC_RETAIL_UP_SUCCESS,
  EXPORT_HDFC_RETAIL_UP_FAIL,
  UPDATE_HDFC_RETAIL_UP_REQUEST,
  UPDATE_HDFC_RETAIL_UP_SUCCESS,
  UPDATE_HDFC_RETAIL_UP_FAIL,
  DELETE_HDFC_RETAIL_UP_REQUEST,
  DELETE_HDFC_RETAIL_UP_SUCCESS,
  DELETE_HDFC_RETAIL_UP_FAIL,
  BULK_DELETE_HDFC_RETAIL_UP_REQUEST,
  BULK_DELETE_HDFC_RETAIL_UP_SUCCESS,
  BULK_DELETE_HDFC_RETAIL_UP_FAIL,
} from '../constants/hdfcRetailUPConstants';

// Get HDFC Retail UP Records Reducer
export const getHdfcRetailUPRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_HDFC_RETAIL_UP_REQUEST:
      return { loadingGetHdfcRetailUPRecords: true };
    case GET_ALL_HDFC_RETAIL_UP_SUCCESS:
      return {
        loadingGetHdfcRetailUPRecords: false,
        getHdfcRetailUPRecordsData: action.payload,
      };
    case GET_ALL_HDFC_RETAIL_UP_FAIL:
      return {
        loadingGetHdfcRetailUPRecords: false,
        errorGetHdfcRetailUPRecords: action.payload,
      };
    default:
      return state;
  }
};

// Import HDFC Retail UP Records Reducer
export const importHdfcRetailUPReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_HDFC_RETAIL_UP_REQUEST:
      return { loadingImportHdfcRetailUP: true };
    case IMPORT_HDFC_RETAIL_UP_SUCCESS:
      return {
        loadingImportHdfcRetailUP: false,
        importHdfcRetailUPData: action.payload,
      };
    case IMPORT_HDFC_RETAIL_UP_FAIL:
      return {
        loadingImportHdfcRetailUP: false,
        errorImportHdfcRetailUP: action.payload,
      };
    default:
      return state;
  }
};

// Export HDFC Retail UP Records Reducer
export const exportHdfcRetailUPReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_HDFC_RETAIL_UP_REQUEST:
      return { loadingExportHdfcRetailUP: true };
    case EXPORT_HDFC_RETAIL_UP_SUCCESS:
      return {
        loadingExportHdfcRetailUP: false,
        exportHdfcRetailUPData: action.payload,
      };
    case EXPORT_HDFC_RETAIL_UP_FAIL:
      return {
        loadingExportHdfcRetailUP: false,
        errorExportHdfcRetailUP: action.payload,
      };
    default:
      return state;
  }
};

// Update HDFC Retail UP Record Reducer
export const updateHdfcRetailUPReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_HDFC_RETAIL_UP_REQUEST:
      return { loadingUpdateHdfcRetailUP: true };
    case UPDATE_HDFC_RETAIL_UP_SUCCESS:
      return {
        loadingUpdateHdfcRetailUP: false,
        updateHdfcRetailUPData: action.payload,
      };
    case UPDATE_HDFC_RETAIL_UP_FAIL:
      return {
        loadingUpdateHdfcRetailUP: false,
        errorUpdateHdfcRetailUP: action.payload,
      };
    default:
      return state;
  }
};

// Delete HDFC Retail UP Record Reducer
export const deleteHdfcRetailUPReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_HDFC_RETAIL_UP_REQUEST:
      return { loading: true };
    case DELETE_HDFC_RETAIL_UP_SUCCESS:
      return { loading: false, success: true };
    case DELETE_HDFC_RETAIL_UP_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Bulk Delete HDFC Retail UP Records Reducer
export const bulkDeleteHdfcRetailUPReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_HDFC_RETAIL_UP_REQUEST:
      return { loadingBulkDeleteHdfcRetailUP: true };
    case BULK_DELETE_HDFC_RETAIL_UP_SUCCESS:
      return {
        loadingBulkDeleteHdfcRetailUP: false,
        bulkDeleteHdfcRetailUPData: action.payload,
      };
    case BULK_DELETE_HDFC_RETAIL_UP_FAIL:
      return {
        loadingBulkDeleteHdfcRetailUP: false,
        errorBulkDeleteHdfcRetailUP: action.payload,
      };
    default:
      return state;
  }
};